export default {
    items: [
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'full-name',
                    width: 0,
                    props: {
                        hidden: true,
                        formula: {
                            name: 'join',
                            arguments: {
                                targets: [
                                    'first-name',
                                    'last-name'
                                ]
                            }
                        }
                    }
                },
                {
                    type: 'text-field',
                    name: 'first-name',
                    width: 6,
                    props: {
                        label: 'First Name'
                    }
                },
                {
                    type: 'text-field',
                    name: 'last-name',
                    width: 6,
                    props: {
                        label: 'Last Name'
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'role',
                    width: 6,
                    props: {
                        label: 'Role'
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'datepicker',
                    name: 'start-date',
                    width: 6,
                    props: {
                        label: 'Employment Start Date'
                    }
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/equity-appreciation/data_table_forms/equity-appreciation-plan-participants.js